<template>
    <v-expand-transition>
        <div v-if="(sourcesLoaded && suggestedMedias.length > 0 || !sourcesLoaded)"
             class="mt-5">
            <div class="suggestion-container">
                <div class="d-flex">
                    <v-icon class="mr-2" color="warning">info</v-icon>
                    <div class="mt-auto mb-auto">
                        <b style="font-size: 18px;">Images trouvées sur le web</b>
                    </div>
                </div>

                <div class="text-center" v-if="!sourcesLoaded">
                    <div>
                        Nous recherchons votre activité sur le web...
                    </div>
                    <v-progress-circular class="progressbar" indeterminate size="50" width="6">
                    </v-progress-circular>
                </div>

                <div class="mt-5 mb-5">
                    Vous avez ajouté les photos suivantes sur votre compte Google My Business.
                    Si vous en détenez les droits, vous pouvez les utiliser pour compléter ce formulaire,
                    en indiquant le copyright pour chaque photo afin qu'elles puissent être diffusées par
                    votre Office de Tourisme.
                </div>

                <div class="d-flex flex-wrap mb-3 justify-start">
                    <v-hover v-slot="{ hover }" v-for="(media, index) in suggestedMedias">
                        <v-img height="180px" max-width="290px"
                               class="m-2 v-media media-suggest"
                               @click="selectMedia(media)"
                               style="border-radius: 8px"
                               :src="media.thumbnail_url !== undefined && media.thumbnail_url !== null ?
                                    media.thumbnail_url : media.origin_url">
                            <div class="media-logo">
                                <img :src="'/images/logo-' + media.source.type + '.jpg'" style="width: 30px;">
                            </div>

                            <v-expand-transition>
                                <div v-if="hover"
                                     class="transition-fast-in-fast-out darken-2 v-card--reveal
                                            display-3 white--text text-center"
                                     style="height: 60px; position: absolute; bottom: 0;
                                               width: 100%; background-color: rgba(0,0,0,0.4);">

                                    <v-btn class="default-button text-none"
                                           @click="addSuggestedMedia(index)"
                                           style="transform: translateY(-50%);
                                                  position: relative;top: 25%">
                                        Ajouter
                                    </v-btn>
                                </div>
                            </v-expand-transition>
                        </v-img>
                    </v-hover>
                </div>
            </div>

            <v-snackbar v-model="displaySnackBar" bottom color="primary" :timeout="8000">
                <span>
                    La photo a été ajoutée à votre réponse.
                    Pour nous permettre de la diffuser, il est impératif d'indiquer son
                    <b style="color:#a4ffa4;">copyright</b>.
                </span>
            </v-snackbar>

            <media-full-screen-modal v-if="selectedMedia !== null && mediaFullScreenDialog"
                                     :media="selectedMedia">
            </media-full-screen-modal>
        </div>
    </v-expand-transition>
</template>

<script>
import {mapState, mapMutations, mapGetters} from "vuex"
import MediaFullScreenModal from "../modals/MediaFullScreenModal.vue";
export default {
    name: "MediaSuggestion",
    components: {MediaFullScreenModal},
    props: ['field'],
    data() {
        return {
            displaySnackBar: false,
            selectedMedia: null,
            addMod: false
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'suggestedMedias', 'sourcesLoaded', 'mediaFullScreenDialog']),
        ...mapGetters('web_form', ['getCodeFromField']),
        ...mapState("webFormStyle", ["primaryColor"]),
        fieldCode() {
            return this.getCodeFromField(this.field)
        }
    },
    methods: {
        ...mapMutations('web_form', ['addMedia', 'setMediaFullScreenDialog']),
        selectMedia(media) {
            if (!this.addMod) {
                this.selectedMedia = media
                this.setMediaFullScreenDialog(true)
            }
        },
        addSuggestedMedia(index) {
            this.addMod = true

            let media = this.suggestedMedias[index]

            this.pushMedia(media.origin_url, media.thumbnail_url, media.source, false)
            this.suggestedMedias.splice(index, 1)

            this.displaySnackBar = true

            setTimeout(() => {
                this.addMod = false
            }, 1000)
        },
        pushMedia(originUrl, thumbnailUrl, source = null, temp = true, copyright = null, height = null, width = null) {
            let media = {
                thumbnail_url: thumbnailUrl,
                name: null,
                copyright: copyright,
                temp: temp,
                origin_url: originUrl,
                source: source,
                is_image: true,
                height: height,
                width: width
            }

            this.addMedia(media)
        }
    }
}
</script>

